import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const GatheringCard = ({ gathering, index = 0 }) => {
  const upcoming = gathering.status === "upcoming";
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE, delay: (index % 3) * 0.08 }}
      data-testid={`gathering-card-${gathering.slug}`}
    >
      <Link to={`/gatherings/${gathering.slug}`} className="group block">
        <div className="relative aspect-[4/5] w-full overflow-hidden rounded-sm bg-gaia-charcoal">
          <img
            src={gathering.cover}
            alt={gathering.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent opacity-70 transition-opacity duration-700 group-hover:opacity-90" />
          <span
            className={`absolute left-4 top-4 rounded-full px-3 py-1 font-sans text-[10px] uppercase tracking-[0.24em] backdrop-blur-md ${
              upcoming ? "bg-gaia-terracotta/90 text-gaia-bg" : "bg-black/30 text-gaia-bg/90"
            }`}
          >
            {upcoming ? "Upcoming" : gathering.date}
          </span>
        </div>

        <div className="mt-6">
          <span className="font-sans text-[11px] uppercase tracking-[0.28em] text-gaia-taupe">
            {gathering.location}
          </span>
          <h3 className="mt-3 font-serif text-2xl font-light leading-snug tracking-tight text-gaia-charcoal transition-colors duration-500 group-hover:text-gaia-terracotta md:text-[28px]">
            {gathering.title}
          </h3>
          <p className="mt-3 max-w-md font-sans text-sm font-light leading-relaxed text-gaia-charcoal/65">
            {gathering.excerpt}
          </p>
          <span className="mt-5 inline-flex items-center gap-2 font-sans text-[11px] uppercase tracking-[0.24em] text-gaia-charcoal">
            {upcoming ? "View & Reserve" : "View Gathering"}
            <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1.5" />
          </span>
        </div>
      </Link>
    </motion.div>
  );
};

export default GatheringCard;
